module.exports = __webpack_public_path__ + "assets/028f179ab6a547730bf954b4263ba7d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channels/ro/5.png
// module id = 354
// module chunks = 1